import omitBy from 'lodash/omitBy';
import map from 'lodash/map';
import { clearFilters, setFilters } from 'store/propertyAvailability/propertyAvailabilityActions';
import { getFilters } from 'store/propertyAvailability/propertyAvailabilitySelectors';
import { interactionEvent } from 'lib/analytics/gtmEventShapes';
import { getPageFromState } from './helpers';

const diff = (last, next) => omitBy(next, (value, key) => last[key] === value);

const emitUpdateQueryInteractionEvent = (action, prevState) => {
  const page = getPageFromState(prevState);
  const prevFilters = getFilters(prevState);
  const changeset = diff(prevFilters, action.payload);
  const changeEvents = map(changeset, (value, key) => {
    switch (key) {
      case 'freeCancellation':
        return interactionEvent({ type: 'Room Type Filters', value: `Free Cancellation ${value ? 'Selected' : 'Reset'}`, page: page.name });
      case 'depositPay':
        return interactionEvent({ type: 'Room Type Filters', value: `Deposit Pay ${value ? 'Selected' : 'Reset'}`, page: page.name });
      case 'classicRewards':
        return interactionEvent({ type: 'Room Type Filters', value: `Classic Rewards ${value ? 'Selected' : 'Reset'}`, page: page.name });
      default:
        break;
    }
  });

  return changeEvents.length ? changeEvents : null;
};

export default {
  [setFilters]: emitUpdateQueryInteractionEvent,
  [clearFilters]: emitUpdateQueryInteractionEvent,
};
